import React, { Component, Fragment } from 'react'
import ToolbarSimple from '../../../../Utils/Toolbar/ToolbarSimple';

import Grid from '../../../../Utils/Grid/index';
import Modal from 'react-responsive-modal';
import LoadMask from "Utils/LoadMask/LoadMask";
import {standardActions} from "../../../../Utils/Grid/StandardActions";
import ToolbarMovimientos from '../FiltrosMovimientos';
import { RenderMoneda, RenderDateTime } from "Utils/renderField/renderTableField";
import { TIPOS_DESPACHOS } from '../../../../../../utility/constants'
import { iconos } from '../../../../../../utility/icons';
import ReajusteForm from '../reajusteForm';


export default class KardexTransicionGrid extends Component {
    state = {
        producto: null,
        setOpenModalAccionesProd: false,
    }
    componentDidMount(){
        this.props.getKardexBodegasTransicion(1, this.props.idBodega);
        this.props.selectUsuarios();
        this.props.selectTipos();
    }

    pageChange = (page) => {
        this.props.getKardexBodegasTransicion(page, this.props.idBodega);
    }

    /* componentWillMount() {
        const { leer, page, listDS } = this.props;
        leer(this.props.match.params.id);
        this.props.getDespachosPendientes(this.props.match.params.id);
        // lectura de los despachos

    } */

    searchInventario = (search) => {
        const tab = 3;
        this.props.searchChangeTransicion(search, this.props.match.params.id, tab);
    }

    botonRealizarReajusteMateriaPrima = (id, row) => {
        const producto = {
            id: row.producto__id,
            codigo: row.producto__codigo,
            nombre: row.producto__nombre,
            empresa: {id: row.bodega__id},
        }

        return (
            <a className="px-2" style={{cursor: "pointer", color: "#c4183c"}} onClick={
                (e)=>{
                    e.preventDefault();
                    this.setState({producto: producto});
                    this.setState({setOpenModalAccionesProd: true});
                }
            }>
                <img
                    className="action-img"
                    title="Reajustar o baja"
                    src={iconos.baja_reajuste}
                    alt="Reajustar o baja" />
            </a>
        )
    }

    handleSubmitReajusteProd = (values) => {
        let valores = _.cloneDeep(values);
        valores.cantidad = Number(values.cantidad);
        valores.bodega = Number(values.bodega);
        valores.tipo_movimiento = Number(values.tipo_movimiento);
        if (valores.vehiculo)
            valores.vehiculo = valores.vehiculo.id
        this.props.reajustarInventarioTransicion(valores, this.props.id_bodega);
    }

    render() {
        const { idBodega, kardex_transicion, loader, listar: onPageChange, onSortChange, page_kardex,
            changeUsuario, changeTipo, mostrarBodegasVirtuales
        } = this.props;

        return (
            <Fragment>

                <Modal open={this.state.setOpenModalAccionesProd}
                    classNames={{ modal: 'modal-xl', }}
                    onClose={(e) => {
                        this.setState({setOpenModalAccionesProd: false});
                    }} center>
                    <div className="">
                        <h2 className="text-center text-primary text-uppercase">SELECCIONAR TIPO ACCIÓN</h2>
                    </div>
                    <ReajusteForm
                        producto={this.state.producto}
                        initialValues={{
                            producto: this.state.producto ? this.state.producto.id : 0,
                            bodega: idBodega,
                            tipo_movimiento: "50"
                        }}
                        onSubmit={this.handleSubmitReajusteProd}
                        cerrarModal={() => {this.setState({setOpenModalAccionesProd: false});}}
                    />
                </Modal>

                <ToolbarMovimientos
                    changeUsuario={changeUsuario}
                    usuarios={this.props.usuarios}
                    changeTipo={changeTipo}
                    tipos={this.props.tipos}
                    id_bodega={this.props.match.params.id}
                    dateStart = {this.props.dateStart}
                    setDateStart = {this.props.setDateStart}
                    dateEnd= {this.props.dateEnd}
                    setDateEnd = {this.props.setDateEnd}

                    // Prosp únicamente para Bodegas de Transicion
                    mostrarBodegasVirtuales={mostrarBodegasVirtuales}
                    getKardexBodegasTransicion={this.props.getKardexBodegasTransicion}
                    es_bodega_mp={this.props.es_bodega_mp}
                    setEsBodegaPM={this.props.setEsBodegaPM}
                    changeKardexTipoMovimiento={this.props.changeKardexTipoMovimiento}
                    changeOrigenMovimiento={this.props.changeOrigenMovimiento}
                    changeUsuarioTransicion={this.props.changeUsuarioTransicion}
                    changeTipoTransicion={this.props.changeTipoTransicion}
                    setDateStartTransicion={this.props.setDateStartTransicion}
                    setDateEndTransicion={this.props.setDateEndTransicion}
                />
                <br />
                <ToolbarSimple
                    textBoton={this.props.permisos.crear_editar_bodegas ? "Despachar" : undefined}
                    margen={"0"}
                    ruta={`/estado_bodega/crear/${this.props.match.params.id}`}
                    buscar={this.searchInventario}
                    buscador={this.props.search}
                    placeholder={"Buscar por: Nombre, Código, No. Despacho"}
                    permisos={true}
                />
                <br />
                <LoadMask loading={loader} light type={"TailSpin"}>
                    <Grid
                        data={kardex_transicion}
                        page={page_kardex}
                        loading={loader}
                        onPageChange={this.pageChange}
                        onSortChange={onSortChange}
                        hover
                        striped
                    >
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            width="2%"
                            // dataSort
                            isKey
                            dataFormat={cell => ""}
                        >
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="despacho_detalle__despacho__fecha"
                            // dataSort
                            dataFormat={
                                (cell, row) => (
                                    <RenderDateTime fecha={cell} />
                                )
                            }
                        >
                            FECHA
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="producto__nombre"
                            // dataSort
                        >
                            PRODUCTO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="anterior"
                        >
                            ANTERIOR
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="cantidad"
                            dataFormat={
                                (cell, row) => (
                                    cell && cell > 0 ? cell : row.despacho_detalle__cantidad
                                )
                            }
                        >
                            CANTIDAD
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="inventario"
                        >
                            INVENTARIO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="tipo"
                            dataFormat={
                                (cell, row) => (cell)
                            }
                        >
                            TIPO MOVIMIENTO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="tipo_movimiento_transicion_display"
                            // dataSort
                            dataFormat={
                                (cell, row) => (cell)
                            }
                        >
                            ORIGEN MOVIMIENTO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="despacho_detalle__despacho__no_despacho"
                            // dataSort
                        >
                            NO DESPACHO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="usuario"
                            // dataSort
                        >
                            REALIZADO POR
                        </TableHeaderColumn>
                    </Grid>
                </LoadMask>
            </Fragment>

        );
    }
}
